import request from "../request";
import sysrequest from "../sysrequest";
// 熱門標籤相關API

const api = {
  //取得全部熱門標籤列表
  //
  getAllHotTags(data) {
    const obj = {
      url: "/bid/demo_v1/hot_tags/",
      method: "get",
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  //更新熱門標籤
  updateHotTags(data) {
    const obj = {
      url: "/bid/demo_v1/hot_tags/update/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  //重置熱門標籤
  resetHotTags(data) {
    const obj = {
      url: "/bid/demo_v1/hot_tags/reset/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },
};

export default api;
